__webpack_require__.p = "/wp-content/themes/mechta/assets/js/dist/";